//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name:'Rockall',
  data() {
    return {
      descTxt:'',
      form:{
        ag:'',
        sh:'',
        co:'',
        di:'',
        bl:'',
      },
      hasScore:false,
      disabled:false,
      dataList:[
        {value:"0",name:'<60',shortName:'<60'},
        {value:"1",name:'60-79',shortName:'60-79'},
        {value:"2",name:'≥80',shortName:'≥80'},
      ],
      dataList2:[
        {value:"0",name:'无休克',shortName:'无休克"'},
        {value:"1",name:'心动过速（收缩压＞100mmHg，心率＞100次/分）',shortName:'心动过速'},
        {value:"2",name:'低血压（收缩压＜100mmHg）',shortName:'低血压'},
      ],
      dataList3:[
        {value:"0",name:'无重大合并症',shortName:'无'},
        {value:"2",name:'心力衰竭、冠脉疾病和其他严重伴发疾病',shortName:'重大合并症'},
        {value:"3",name:'肝/肾衰竭和肿瘤播散',shortName:'肾、肝、癌'},
      ],
      dataList4:[
        {value:"0",name:'Mallory-Weiss综合征或无病变及出血征象',shortName:'Mallory-Weiss'},
        {value:"1",name:'溃疡等其他病变',shortName:'其他诊断'},
        {value:"2",name:'上消化道恶性肿瘤',shortName:'上消化道恶性肿瘤'},
      ],
      dataList5:[
        {value:"0",name:'无或仅有黑斑',shortName:'无或仅有黑斑'},
        {value:"2",name:'上消化道血液潴留，粘附血凝块，血管显露或喷血',shortName:'血液、血块、血管'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // ag + sh + co + resp
        let result = form.ag + form.sh + form.co + (form.di ? form.di : 0) + (form.bl ? form.bl : 0)

        if (result<3) {
          self.descTxt = '良好预后'
        } else if(result > 8) {
          self.descTxt = '死亡高危'
        }else {
          self.descTxt = ''
        }
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ER/Rockall.vue